import { PhysiotherapyOriginType, CaseType } from "@teamprevent/common/model";

import { routes as ohCases } from "./ohCase/routes";
import { routes as actionableTasks } from "./actionableTasks";
import { routes as employeeSatisfactionSurvey } from "./employeeSatisfactionSurvey/routes";
import { routes as immunisationHistory } from "./immunisationHistory";
import { routes as stressRiskAssessment } from "./stressRiskAssessment/routes";

export const routes: any = {
    "/": {
        title: "Home",
    },
    ...ohCases,
    ...actionableTasks,
    "/physiotherapy": {
        title: "Physiotherapy",
        requiredProducts: [CaseType.PHYSIOTHERAPY_REFERRAL],
        physioOrigins: [PhysiotherapyOriginType.SELF_REFERRAL]
    },
    ...employeeSatisfactionSurvey,
    ...immunisationHistory,
    ...stressRiskAssessment
};
